export const enum BUTTON_VARIANT {
	DEFAULT = 'default',
	INVERSE = 'inverse',
}
